import PropTypes from 'prop-types';
import React from 'react';
import { BlockIcon } from '../icons';
import Confirmation from '../confirmation';
import withTranslate from '../../hoc/with-translate';

export const BlockConfirmation = ({ title, message, confirmButton, onConfirm, onCancel, t }) =>
  <Confirmation
    icon={BlockIcon}
    title={title}
    confirm={confirmButton}
    onConfirm={onConfirm}
    cancel={t('block-confirmation.cancel-button')}
    onCancel={onCancel}
  >
    <p>
      {message}
    </p>
  </Confirmation>;

BlockConfirmation.propTypes = {
  t: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  title: PropTypes.string,
  confirmButton: PropTypes.string,
  message: PropTypes.string,
};

export default withTranslate(BlockConfirmation);



// WEBPACK FOOTER //
// ./app/components/block-confirmation/block-confirmation.js